<template>
	<section class="main-content contentblocks">
		<div class="row row-header align-center white">
			<div v-if="contentBlocksContent.length">
				<h2 class="subtitle">
					{{ contentBlocksSubtitle }}
				</h2>
				<div v-parse-links v-html="contentBlocksContent" />
			</div>
		</div>
		<div v-for="(block, index) in contentblocks" :key="block.ID" class="row contentblock">
			<div class="row contentblock">
				<div class="columns column4 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
					<h2>{{ block.header }}</h2>
					<div v-parse-links v-html="block.content" />
				</div>
				<div class="contentblock-image" :class="{ 'has-video': block.embedCode }">
					<div v-if="block.embedCode" class="video-foreground">
						<div>
							<iframe
								:src="`${block.embedCode}?loop=1&muted=1&badge=0&autoplay=1&controls=0&autopause=0&player_id=0`"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								title="Ibis Tilburg"
							/>
						</div>
					</div>
					<picture v-else-if="block.image">
						<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
						<source :srcset="block.image" />
						<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
					</picture>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
	contentBlocksContent: { type: String, default: '' },
	contentBlocksSubtitle: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.video-foreground {
	position: absolute;
	top: 0;
	left: -150%;
	width: 400%;
	height: 130%;

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 2;
	}
}

.contentblocks {
	background: var(--contentblock-background-color);
}

.background-light {
	background: var(--alternating-background-color);
}

.contentblock {
	margin: 20px auto;
	position: relative;

	.column4 {
		width: 36%;
	}
}

.row-header {
	max-width: 1000px;
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 69%;
	z-index: 1;
	overflow: hidden;
}

.contentblock-content {
	background: var(--alternating-background-color);
	box-shadow: 0 24px 24px rgb(0 0 0 / 25%);
	backdrop-filter: blur(34px);
	padding: 50px 60px;
	margin: 50px auto;
	position: relative;
	z-index: 2;
}

.row:nth-child(even) .contentblock-image {
	left: 0;
	right: auto;
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 1080px) {
	.contentblock {
		.column4 {
			width: 48%;
		}
	}
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
		z-index: 2;

		&.has-video {
			min-height: 50vw;
		}
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;

		.column4 {
			width: 92%;
			margin: -50px auto 0;
			z-index: 4;
		}
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 30px;
	}
}
</style>
